import axios from 'axios';
import { ref } from 'vue'
 
const http =  'http://flower.520mus.top:54009/520muspayapi'  // 发布

//const http =  'https://localhost:44392/api' //开发环境



///api/pay/CreatePayCenterUrl/{clientid}/{unionid}/{orderId}/{productid}/{totalPay}/{description}
export const CreatePayCenterUrl = (clientid: any , unionid: any,orderId: any, productid: any,totalPay: any,description: any) => {
const params = new URLSearchParams();
params.append('clientid', clientid);
params.append('unionid', unionid); 
params.append('orderId', orderId);
params.append('productid', productid);
params.append('totalPay', totalPay); 
params.append('description', description); 
    //return axios.post(http + "/user/loginflower?username="+ userName+"&pwdmima="+pwd+"&code="+uniqueCode+"&code="+code+"&autologin="+autoLogin
    return axios.get(http + "/pay/CreatePayCenterUrl/" +clientid+"/"+unionid+"/"+orderId+"/"+productid+"/"+encodeURIComponent(totalPay)+"/"+encodeURIComponent(description)
    , {
          headers:{ 
            'Content-Type':"application/json;charset=UTF-8"
          }
        }
        );   
  }  

  export const CreatePayUrlByCao919 = (price: string) => { 
    return axios.get(http + "/pay/CreatePayUrlByCao919/"+encodeURIComponent(price)
      ,{
          headers:{
            'Content-Type':"application/json;charset=UTF-8"
          }
        }
        );  
  } 


  // export const getTokenvue2login = (userName: any , pwd: any,code: any, uniqueCode: any,autoLogin: any) => {
// const params = new URLSearchParams();
// params.append('username', userName);
// params.append('pwdmima', pwd); 
// params.append('uniqueCode', uniqueCode);
// params.append('code', code);
// params.append('autologin', autoLogin); 
//     //return axios.post(http + "/user/loginflower?username="+ userName+"&pwdmima="+pwd+"&code="+uniqueCode+"&code="+code+"&autologin="+autoLogin
//     return axios.post(http + "/user/loginflower" ,params
//     , {
//           headers:{
//             // 'Content-Type':"application/json;charset=UTF-8"
//             'Content-Type':"application/x-www-form-urlencoded;charset=UTF-8" 
//           }
//         }
//         );   
//   } 

  